// extracted by mini-css-extract-plugin
export var externalLink = "_9z-0";
export var internalLinkLabel = "_9z-1";